import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext("light");

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const mode = params.get("mode") === "dark" ? "dark" : "light";
    setTheme(mode);

    document.documentElement.classList.toggle("dark", mode === "dark");
  }, []);

  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
